// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"31885502","225":"47256a65","395":"7604f7bb","453":"70567d22","484":"3ec0de50","530":"4b6f0c7a","571":"f9dae419","576":"7f22005b","639":"9370abec","693":"3e39936a","700":"7c017157","838":"8621bf47","885":"73943737"}[chunkId] + ".chunk.js";
};